import { Link, NavLink } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";
import type { Locale, MessageKey } from "../i18n/messages";
import { logout } from "../lib/auth";

export function LanguageToggle() {
  const { locale, setLocale, t } = useLanguage();
  const options: Locale[] = ["th", "en"];
  return (
    <div role="group" aria-label={t("language")} style={{ display: "inline-flex", gap: 4 }}>
      {options.map((l) => (
        <button
          key={l}
          className="btn btn--secondary"
          style={{ minHeight: 36, padding: "0 12px" }}
          aria-pressed={locale === l}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

const NAV: { to: string; key: MessageKey; end?: boolean }[] = [
  { to: "/", key: "dashboard", end: true },
  { to: "/assumptions", key: "assumptions" },
  { to: "/projection", key: "projection" },
  { to: "/montecarlo", key: "montecarlo" },
];

export function AppHeader() {
  const { t } = useLanguage();
  return (
    <header className="app-header">
      <div className="app-header__brand">
        <Link to="/" className="app-header__name">
          {t("appName")}
        </Link>
        <nav className="app-nav" aria-label={t("sections")}>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `app-nav__link${isActive ? " app-nav__link--active" : ""}`}
            >
              {t(n.key)}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="app-header__actions">
        <LanguageToggle />
        <button className="btn btn--secondary" style={{ minHeight: 36 }} onClick={logout}>
          {t("signOut")}
        </button>
      </div>
    </header>
  );
}
